import { RequestService } from '../../../../common/services/RequestService';
import { GET_CUSTOMER } from '../constants';
import { adjustCustomerByIdData } from './adjustCustomerByIdData';

export const getCustomerById = async (profileId) => {
  const response = await RequestService.get(
    GET_CUSTOMER + profileId
  );
  return response.data && adjustCustomerByIdData(response.data);
};
